var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-widgetCategoryBar" },
    [
      _c(
        "div",
        {
          staticClass: "search-widgetCategoryBar__searchBtn",
          on: {
            click: function($event) {
              return _vm.$store.commit("OPEN_SEARCH_DIALOG")
            }
          }
        },
        [_c("i", { staticClass: "icon-search" })]
      ),
      _vm.$store.state.dialogs.searchDialog
        ? _c(
            "v-dialog",
            {
              attrs: {
                "content-class": "dialog-search",
                "max-width": "572px",
                persistent: _vm.isDialogPersistent
              },
              model: {
                value: _vm.$store.state.dialogs.searchDialog,
                callback: function($$v) {
                  _vm.$set(_vm.$store.state.dialogs, "searchDialog", $$v)
                },
                expression: "$store.state.dialogs.searchDialog"
              }
            },
            [
              _c("search-popup", {
                on: {
                  close: function($event) {
                    return _vm.$store.commit("CLOSE_SEARCH_DIALOG")
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }